<template>
  <div class="agentgrid-mark" role="img" aria-label="Agent Grid">
    <span v-for="(opacity, index) in cells" :key="index" class="agentgrid-mark-cell" :style="{ opacity }" />
  </div>
</template>

<script>
/**
 * The Agent Grid mark: a 3x3 grid of cells with a clockwise opacity spiral.
 */
export default {
  name: 'AgentGridMark',
  data() {
    return {
      cells: [0.3, 0.2, 0.1, 0.4, 0.9, 0.8, 0.5, 0.6, 0.7]
    };
  }
};
</script>

<style lang="scss" scoped>
.agentgrid-mark {
  width: 24px;
  height: 24px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.agentgrid-mark-cell {
  display: block;
  background: var(--agentgrid-text-primary);
}
</style>
